const defaultLocale = process.env.GATSBY_DEFAULT_LOCALE

const extractLocaleFromUrl = location => {
  const match = location.pathname.match(/^\/([a-z]{2})(\/|$)/)
  return match ? match[0].replace(/\//g, '') : defaultLocale || undefined
}

export default extractLocaleFromUrl
